module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid align-end"
  }, _vm._l((_vm.main.items), function(item, index) {
    return _c('item', {
      attrs: {
        "item": item,
        "mosaic": "true"
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9f7e12e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 477
// module chunks = 2